import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SearchForm } from "./SearchForm";
import { DesktopMenu } from "./DesktopMenu";
import { Topbar } from "./Topbar";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { TcLogo } from "common/components/TcLogo";
interface MastheadProps {
  noDesktopMenu?: boolean;
}
export interface HeaderProps {
  noDesktopMenu?: boolean;
  noMasthead?: boolean;
  wide?: boolean;
}
const Masthead = t0 => {
  "use memo";

  const $ = _c(13);
  const {
    noDesktopMenu
  } = t0;
  const t = useTranslations("layout.header");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <TcLogo width={350} height={40} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== t) {
    t2 = t("slogan");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <div className="flex flex-col items-start">{t1}<div className="text-2xs mt-1 font-bold text-gray-700">{t2}</div></div>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <SearchForm />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3) {
    t5 = <div className="mx-auto flex justify-between">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== noDesktopMenu) {
    t6 = noDesktopMenu ? null : <DesktopMenu />;
    $[8] = noDesktopMenu;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t5 || $[11] !== t6) {
    t7 = <div className="hidden border-b border-solid border-gray-200 text-center lg:block"><div className="hidden font-sans lg:block"><header className="bg-masthead pt-5"><div className="tc-container container mx-auto">{t5}{t6}</div></header></div></div>;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};
export const Header = t0 => {
  "use memo";

  const $ = _c(8);
  const {
    noDesktopMenu,
    noMasthead,
    wide
  } = t0;
  let t1;
  if ($[0] !== wide) {
    t1 = <Topbar wide={wide} />;
    $[0] = wide;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== noDesktopMenu || $[3] !== noMasthead) {
    t2 = noMasthead ? null : <Masthead noDesktopMenu={noDesktopMenu} />;
    $[2] = noDesktopMenu;
    $[3] = noMasthead;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <React.Fragment>{t1}{t2}</React.Fragment>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};